import script from "./App.vue?vue&type=script&setup=true&lang=ts&name=app"
export * from "./App.vue?vue&type=script&setup=true&lang=ts&name=app"

const __exports__ = script;

export default __exports__